enum FinderType {
  DIALOG = 'dialog',
  FIELD = 'field',
  INLINE = 'inline',
}

export default FinderType;
